<template>
	<div>

		<div class="row">
			<div class="alert alert-warning" role="alert">
				<i class="fa fa-exclamation fa-fw"></i>
				Any application with that token will have full access to the selected namespace.
			</div>

			<loader v-if="!namespaces"></loader>

			<div class="form-group" v-if="namespaces && namespaces.length > 0" @click="createNewNamespace=false">
				<div class="custom-control custom-radio">
					<input type="radio" v-model="createNewNamespace" @focus="createNewNamespace=false" value="false" class="custom-control-input" name="radio-stacked" required>
					<label class="custom-control-label">Select an exising namespace:</label>
				</div>

				<select v-model="existingNamespace" @focus="createNewNamespace=false">
					<option v-for="n in namespaces" :key="n.namespace" :value="n.namespace">
						{{ n.namespace }}
					</option>
				</select>
			</div>

			<div class="form-group" v-if="namespaces" @click="createNewNamespace=true">
				<div class="custom-control custom-radio">
					<input type="radio" v-model="createNewNamespace" value="true" @focus="createNewNamespace=true" class="custom-control-input" name="radio-stacked" required>
					<label class="custom-control-label">Create a new namespace:</label>
				</div>

				<input v-model="newNamespace" class="form-control tests_namespace_name_input" @focus="createNewNamespace=true" placeholder="">
			</div>

			<div class="row" v-if="showExpiration && namespaces">
				<label class="custom-control-label">Expires in</label>
				<select v-model="expiration" class="expiration-select">
					<option v-for="o in expirationOptions" :key="o.expiration" :value="o.expiration">
						{{ o.label }}
					</option>
				</select>
			</div>

			<button v-if="!(showTokenGeneration == 'false')" id="gen-token-btn" class="btn btn-primary tests_create_token_action" type="button" @click="generateToken()">Generate Access Token</button>
		</div>

		<div class="row" v-if="namespaces && token">
			<label>Access Token:</label>
			<div class="token-group">
				<input type="text" class="form-control tests_token_value_input" placeholder="" :value="token" :ref="'tokenref'" @click="onClickToken" />
			</div>
		</div>
	</div>
</template>

<script>
const generateTokenMixin = require("@/utils/generate-token-mixin");
const router = require("@/router");
const logger = require("@/utils/logger");

export default {
  props: ["showTokenGeneration", "showExpiration"],
  mixins: [generateTokenMixin.default],
  methods: {},
  watch: {
    newNamespace: function(val, oldVal) {
      this.$emit("onNamespaceChanged", val);
    },
    existingNamespace: function(val, oldVal) {
      this.$emit("onNamespaceChanged", val);
    },
    expiration: function(val, oldVal) {
      this.$emit("onExpirationChanged", this.getExpiration());
    }
  },
  mounted() {
    this.$emit("onExpirationChanged", this.getExpiration());
  }
};
</script>

<style scoped>
.token-group input {
  width: 100%;
}
.alert-warning {
  border-color: #ffc243;
  font-weight: bold;
}
.row {
  margin-left: 0;
  margin-right: 0;
}
#gen-token-btn {
  margin-bottom: 15px;
}
select {
  width: 100%;
}
.expiration-input,
.expiration-select {
  display: inline;
  margin: 0 0 15px 10px;
}
.expiration-input {
  width: 55px;
}
.expiration-select {
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/CreateToken.vue